// console.log('Header drawer contents goes here');



class HeaderDrawer extends HTMLElement {
    constructor() {
        super();

        this.HeaderDrawer = this;
        this.HeaderDrawerToggle = this.querySelector('.header-drawer-toggle');
        this.HeaderDrawerDetails = this.querySelector('.header-drawer-details');
        this.subMenuItemIcons = this.querySelectorAll('.header-drawer-main-menu-item-icon');
        this.subMenuItemToggles = this.querySelectorAll('.header-drawer-main-menu-subitems-panel__title');
        // this.subMenuItemIcons = this.querySelectorAll('.header-drawer-main-menu-item-icon');
        // this.HeaderDrawerClose = this.querySelector('.cart-drawer-close');
        // this.HeaderDrawerOverlay = this.querySelector('.cart-drawer-overlay');

        this.HeaderDrawerToggle.addEventListener('click', (event) => this.onClick(event))

        // this.HeaderDrawerClose.addEventListener('click', () => this.close())
        // this.HeaderDrawerOverlay.addEventListener('click', () => this.close())


        document.addEventListener('click', (event) => {
            const headerDrawer = this.HeaderDrawer;
            if (event.target !== headerDrawer && !headerDrawer.contains(event.target)) {
                this.close()
            }
        })


        for(let subMenuItemIcon of this.subMenuItemIcons ){
            subMenuItemIcon.addEventListener('click', () => this.subMenuClick(subMenuItemIcon))
        }

        for(let subMenuItemToggle of this.subMenuItemToggles){
            subMenuItemToggle.addEventListener('click', () => this.subMenuToggleClick(subMenuItemToggle))
        }
    }

    onClick(event) {
        event.preventDefault();

        if( this.classList.contains('active') ){
            this.close();
        }
        else{
            this.open()
        }
    }

    open() {
        // this.HeaderDrawerDetails.style.display = 'flex';
        this.HeaderDrawerDetails.classList.add('visible');

        setTimeout(() => {
            this.HeaderDrawer.classList.add('active')
        }, 50);
    }
    close() {
        this.HeaderDrawer.classList.remove('active')

        setTimeout(() => {
            // this.HeaderDrawerDetails.style.display = 'none';
            this.HeaderDrawerDetails.classList.remove('visible');
        }, 300);
    }

    subMenuClick(subMenuItemIcon){

        const subMenuItem = subMenuItemIcon.parentNode.parentNode;
        
        this.HeaderDrawerDetails.classList.add('inactive');
        subMenuItem.classList.contains('active') ? subMenuItem.classList.remove('active') : subMenuItem.classList.add('active')
    }

    subMenuToggleClick(subMenuItemIcon){
        
        const subMenuItem = subMenuItemIcon.parentNode.parentNode;
        
        this.HeaderDrawerDetails.classList.remove('inactive');
        subMenuItem.classList.remove('active')
    }

}

customElements.define('header-drawer', HeaderDrawer);


$(document).ready(function() {    
    $('.section-header-main-menu-subitem').click(function() {
    	var menuname = $(this).find("a").find("span").text();
    	// set the item in localStorage
    	localStorage.setItem('menuname', menuname);    	
    });
    if (window.location.href.indexOf("/interior-design-services") > -1) {
	    var menuvalue = localStorage.getItem('menuname');
	    console.log("menuvalue" + menuvalue);
	    const array = ['Full Service Interior Design', 'Staging', 'Furniture and Space Planning', 'Design Guidance', 'New Build Finish Selections', 'E-Design']; 	      
	    if (array.indexOf(menuvalue) !== -1) {
    	    $("html, body").animate({
    	    	scrollTop: $(".tab-with-content").offset().top
    	    }, 100);
    	    $('li.tab-slider--trigger').each(function(element) {
    		    if($(this).text() == menuvalue){
    		    	$(this).trigger("click");
    		    }
    	    });
	    }
    }
});

$(document).ready(function() {    
    $('.header-drawer-main-menu-item-label').click(function() {
    	var menuname = $(this).find("a").find("span").text();
    	// set the item in localStorage
    	localStorage.setItem('menuname', menuname);    	
    });
    if (window.location.href.indexOf("/interior-design-services") > -1) {
	    var menuvalue = localStorage.getItem('menuname');
	    console.log("menuvalue" + menuvalue);
	    const array = ['Full Service Interior Design', 'Staging', 'Furniture and Space Planning', 'Design Guidance', 'New Build Finish Selections', 'E-Design']; 	      
	    if (array.indexOf(menuvalue) !== -1) {
    	    $("html, body").animate({
    	    	scrollTop: $(".tab-with-content").offset().top
    	    }, 100);
    	    $('li.tab-slider--trigger').each(function(element) {
    		    if($(this).text() == menuvalue){
    		    	$(this).trigger("click");
    		    }
    	    });
	    }
    }
});

// Set a timeout to ensure the function executes after a delay
setTimeout(function () {
    if (window.innerWidth <= 767) {
        document.querySelectorAll('.tab-slider--nav').forEach(function (navBar) {
            var activeLi = navBar.querySelector('li.active');
            if (activeLi) {
                var scrollContainer = navBar.querySelector('.tab-slider--tabs');
                if (scrollContainer) {
                    // Calculate the position to scroll to
                    var scrollTo = activeLi.offsetLeft - scrollContainer.offsetLeft - (scrollContainer.offsetWidth / 2) + (activeLi.offsetWidth / 2);
                    // Scroll the container
                    scrollContainer.scrollLeft = scrollTo;
                }
            }
        });
    }
}, 200);